 

import { useDashboardDataContext } from "@/context/dashboardDataContext";
import VerticalNav from "./NavbarType/VerticalNav";

const Navbars = () => {
  const { activeVariation } = useDashboardDataContext();

  switch (activeVariation) {
    case "vertical":
      return <VerticalNav />;
    default:
      return null;
  }
};

export default Navbars;
